module.exports = __webpack_public_path__ + "img/pcBanner13.74945597.png";